import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
  Button,
  Spinner,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// action
import { registerUser, resetRegisterFlag } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useLocation, useNavigate } from "react-router-dom";

//import images
import logoLight from "../../assets/images/logo-light.png";
import logoAiCare from "../../assets/images/pn.png";
import logoAiCareEsteso from "../../assets/images/aicare.png";
import loghiNazionali from "../../assets/images/loghi-nazionali.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";

const RegisterMail = (props: any) => {
  const history = useNavigate();
  const dispatch: any = useDispatch();
  const location = useLocation();
  const { email } = location.state || {};

  const selectLayoutState = (state: any) => state.Account;
  const registerdatatype = createSelector(selectLayoutState, (account) => ({
    success: account.success,
    error: account.error,
  }));
  // Inside your component
  const { error, success } = useSelector(registerdatatype);

  useEffect(() => {
    if (success) {
      setTimeout(() => history("/login"), 3000);
    }

    setTimeout(() => {
      dispatch(resetRegisterFlag());
    }, 3000);
  }, [dispatch, success, error, history]);

  document.title = "Basic SignUp | Velzon - React Admin & Dashboard Template";

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <div
          className="mb-lg-5"
          style={{ textAlign: "center", backgroundColor: "#fff" }}
        >
          <span className="logo-lg">
            <img
              src={loghiNazionali}
              alt=""
              className="img-fluid"
              style={{ minHeight: 30, maxHeight: 80 }}
            />
          </span>
        </div>
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoAiCare} alt="" height="45" />
                      <img src={logoAiCareEsteso} alt="" height="45" />
                    </Link>
                  </div>
                  <p className="mt-3 fs-15 fw-medium" style={{color: "black"}}>
                    Dashboard AICare
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h3 className="text-primary">
                        Grazie per la tua iscrizione!
                      </h3>
                    </div>
                    <div className="p-2 mt-4">
                      <h5 className="text-primary text-center">
                        Per completare la registrazione, controlla la tua email:
                        <h4
                          className="text-primary"
                          style={{ marginTop: "0.5rem" }}
                        >
                          <a href={`mailto:${email}`} className="text-primary">
                            {email}
                          </a>
                        </h4>
                        e conferma la tua registrazione utilizzando il link fornito!
                      </h5>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-4 text-center">
                  <p className="mb-0">
                    Possiedi già un account?{" "}
                    <Link
                      to="/login"
                      className="fw-semibold text-primary text-decoration-underline"
                    >
                      {" "}
                      Accedi{" "}
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default RegisterMail;
